export type Trailer = {
  title: string;
  url: string;
  poster: string;
  source?: string;
  note?: string;
};

export type Project = {
  slug: string;
  title: string;
  subtitle: string;
  description: string;
  status?: string;
  platforms: string[];
  roles: string[];
  technologies?: string[];
  heroImage: string;
  capsuleImage?: string;
  screenshots?: string[];
  trailers?: Trailer[];
  trailerUrl?: string;
  trailerPoster?: string;
  storeUrl?: string;
  ctaLabel?: string;
  accent?: string;
  mood?: string;
  credits?: string;
  featureGroups?: { title: string; text: string }[];
};

const trailerArchive: Trailer[] = [
  {
    title: "GoBotix Android Game Trailer",
    url: "https://www.youtube.com/watch?v=jRiyHzQ-v44",
    poster: "/assets/games/trailers/gobotix-android.jpg",
    source: "Wix gallery / YouTube"
  },
  {
    title: "POV Car Driving Official Trailer",
    url: "https://www.youtube.com/watch?v=LAcreOvC960",
    poster: "/assets/games/trailers/pov-car-driving.jpg",
    source: "Wix gallery / YouTube"
  },
  {
    title: "Truck Simulator Offroad 4 Official Trailer",
    url: "https://www.youtube.com/watch?v=zjGTTwHdoaA",
    poster: "/assets/games/trailers/truck-simulator-offroad-4.jpg",
    source: "Wix gallery / YouTube"
  },
  {
    title: "Horror Story: Nancy Parker Official Trailer",
    url: "https://www.youtube.com/watch?v=JBquDcWPIHM&t=3s",
    poster: "/assets/games/trailers/nancy-parker.jpg",
    source: "Wix gallery / YouTube"
  },
  {
    title: "Brand new story",
    url: "https://www.youtube.com/watch?v=wFZAGgVl8kI",
    poster: "/assets/games/trailers/brand-new-story.jpg",
    source: "Wix gallery / YouTube"
  },
  {
    title: "Offroad 3 Working progress with maz",
    url: "https://www.youtube.com/watch?v=xZ8iA6slElI",
    poster: "/assets/games/trailers/offroad-3-work-progress.jpg",
    source: "Wix gallery / YouTube"
  },
  {
    title: "New Offroad Physic",
    url: "https://www.youtube.com/watch?v=k4IsgiRgEPE",
    poster: "/assets/games/trailers/new-offroad-physic.jpg",
    source: "Wix gallery / YouTube"
  },
  {
    title: "Truck Simulator: Offroad Official Trailer",
    url: "https://www.youtube.com/watch?v=KV0AlCX9NTw",
    poster: "/assets/games/trailers/truck-simulator-offroad.jpg",
    source: "Wix gallery / YouTube"
  },
  {
    title: "Offroad Chronicles Trailer",
    url: "https://www.youtube.com/watch?v=fKRg6IZ6nCY",
    poster: "/assets/games/trailers/offroad-chronicles.jpg",
    source: "Wix gallery / YouTube",
    note: "The Wix gallery describes this as developed for another publisher by SZ Interactive LTD."
  }
];

export const projects: Project[] = [
  {
    slug: "the-shed",
    title: "The Shed",
    subtitle: "A narrative mystery where time bends in a forgotten garden.",
    description:
      "Explore a weathered garden and long-abandoned outbuilding where memory, consequence, and identity refuse to stay fixed. The world shifts as the story advances, with decisions echoing across timelines and occasional changes in perspective.",
    status: "Coming soon - Demo available on Steam",
    platforms: ["Windows", "Steam"],
    roles: ["Developer", "Publisher"],
    technologies: ["Unity", "Steamworks", "Narrative systems", "Environmental interaction"],
    heroImage: "/assets/games/the-shed/screenshot-1.jpg",
    capsuleImage: "/assets/games/the-shed/header.jpg",
    screenshots: [
      "/assets/games/the-shed/screenshot-1.jpg",
      "/assets/games/the-shed/screenshot-2.jpg",
      "/assets/games/the-shed/screenshot-3.jpg",
      "/assets/games/the-shed/screenshot-4.jpg"
    ],
    trailers: [
      {
        title: "The Shed Steam Trailer",
        url: "https://store.steampowered.com/app/3714920/The_Shed/",
        poster: "/assets/games/the-shed/trailer.jpg",
        source: "Steam"
      }
    ],
    trailerUrl: "https://store.steampowered.com/app/3714920/The_Shed/",
    trailerPoster: "/assets/games/the-shed/trailer.jpg",
    storeUrl: "https://store.steampowered.com/app/3714920/The_Shed/",
    ctaLabel: "Wishlist The Shed on Steam",
    accent: "#b87545",
    mood: "Weathered garden - Memory - Rust - Quiet mystery",
    credits: "Developer: SZ Interactive LTD - Publisher: SZ Interactive",
    featureGroups: [
      { title: "A Garden That Refuses to Stay Still", text: "The same place can become unfamiliar as hidden states, atmospheres, and story fragments surface during exploration." },
      { title: "Timeline and Consequence", text: "Important events and memory imprints are recorded as the player uncovers the chain of decisions shaping the world." },
      { title: "Between 2D and 3D", text: "The story can slip into another perspective when a moment needs to be told differently." },
      { title: "Interactive Atmosphere", text: "Environmental detail, dialogue, and object interaction work together to keep discovery quiet but active." }
    ]
  },
  {
    slug: "jeff",
    title: "JEFF",
    subtitle: "Massacre your everyday problems.",
    description:
      "JEFF is a fast-paced co-op horde shooter and roguelite survival game where everyday frustrations become enemies. Build ridiculous combinations, snowball your power, and survive the chaos alone or with a friend.",
    status: "Planned Release Date: Q4 2026",
    platforms: ["Windows", "Steam"],
    roles: ["Publisher"],
    technologies: ["Unity", "Online co-op", "Roguelite progression"],
    heroImage: "/assets/games/jeff/screenshot-1.jpg",
    capsuleImage: "/assets/games/jeff/header.jpg",
    screenshots: [
      "/assets/games/jeff/screenshot-1.jpg",
      "/assets/games/jeff/screenshot-2.jpg",
      "/assets/games/jeff/screenshot-3.jpg",
      "/assets/games/jeff/screenshot-4.jpg"
    ],
    trailers: [
      {
        title: "JEFF Steam Trailer",
        url: "https://store.steampowered.com/app/4590390/JEFF/",
        poster: "/assets/games/jeff/trailer.avif",
        source: "Steam"
      }
    ],
    trailerUrl: "https://store.steampowered.com/app/4590390/JEFF/",
    trailerPoster: "/assets/games/jeff/trailer.avif",
    storeUrl: "https://store.steampowered.com/app/4590390/JEFF/",
    ctaLabel: "Wishlist JEFF on Steam",
    accent: "#f2b134",
    mood: "Fast action - Social-media chaos - Daily-life demons",
    credits: "Developer: LUDOS DEV - Publisher: SZ INTERACTIVE LTD",
    featureGroups: [
      { title: "Fight Daily-Life Demons", text: "Readable enemy waves turn toxic comments, digital overload, and social pressure into fast-moving combat problems." },
      { title: "Break the Build", text: "Stackable items and upgrades let each run snowball from survival scramble to screen-clearing momentum." },
      { title: "Survive Together", text: "Play solo or in online two-player co-op, balancing positioning, enemy control, and shared survival." },
      { title: "Quick Runs, Immediate Chaos", text: "Short restarts keep the loop sharp: move, upgrade, test a build, and push a little further." }
    ]
  },
  {
    slug: "truck-simulator-offroad",
    title: "Truck Simulator Offroad Series",
    subtitle: "Mobile off-road simulation built around vehicles, terrain, and missions.",
    description:
      "The Truck Simulator Offroad series helped establish SZ Interactive's international mobile audience, combining physics-driven vehicles, difficult terrain, missions, and large off-road environments.",
    status: "Released mobile series",
    platforms: ["Android", "Mobile", "Tablet"],
    roles: ["Original developer"],
    technologies: ["Unity", "Vehicle physics", "Mobile optimisation"],
    heroImage: "/assets/games/truck-simulator-offroad/wix-card.jpg",
    screenshots: ["/assets/games/truck-simulator-offroad/wix-card.jpg"],
    trailers: trailerArchive.filter((trailer) =>
      [
        "Truck Simulator Offroad 4 Official Trailer",
        "Offroad 3 Working progress with maz",
        "New Offroad Physic",
        "Truck Simulator: Offroad Official Trailer"
      ].includes(trailer.title)
    ),
    trailerUrl: "https://www.youtube.com/watch?v=KV0AlCX9NTw",
    trailerPoster: "/assets/games/trailers/truck-simulator-offroad.jpg",
    storeUrl: "https://play.google.com/store/apps/details?id=com.SZInteractive.TruckSimulatorOffroad2",
    ctaLabel: "View Google Play listing",
    accent: "#8aa274",
    credits: "Originally developed by SZ Interactive."
  },
  {
    slug: "gobotix",
    title: "Gobotix: Duo",
    subtitle: "A two-robot isometric puzzle game published by SZ Interactive Ltd.",
    description:
      "Guide two small robots through handcrafted 3D isometric puzzles built around logic, timing, co-op play, mechanisms, portals, and a reactive soundtrack shaped by player actions.",
    status: "Released - Free to play",
    platforms: ["Windows", "Steam"],
    roles: ["Publisher"],
    technologies: ["Unity", "Puzzle systems", "Online co-op", "Steam"],
    heroImage: "/assets/games/gobotix/screenshot-1.jpg",
    capsuleImage: "/assets/games/gobotix/header.jpg",
    screenshots: [
      "/assets/games/gobotix/screenshot-1.jpg",
      "/assets/games/gobotix/screenshot-2.jpg",
      "/assets/games/gobotix/screenshot-3.jpg"
    ],
    trailers: [
      {
        title: "Gobotix: Duo Steam Trailer",
        url: "https://store.steampowered.com/app/4103660/Gobotix_Duo/",
        poster: "/assets/games/gobotix/trailer.jpg",
        source: "Steam"
      }
    ],
    trailerUrl: "https://store.steampowered.com/app/4103660/Gobotix_Duo/",
    trailerPoster: "/assets/games/gobotix/trailer.jpg",
    storeUrl: "https://store.steampowered.com/app/4103660/Gobotix_Duo/",
    ctaLabel: "Play Gobotix: Duo on Steam",
    accent: "#75a7a2",
    credits: "Developer: Ludos Games - Publisher: SZ Interactive LTD"
  },
  {
    slug: "pov-car-driving",
    title: "POV Car Driving",
    subtitle: "A first-person driving project shown in the official Wix trailer archive.",
    description:
      "POV Car Driving is represented on the SZ Interactive Wix page by its official YouTube trailer, separate from the Truck Simulator Offroad and Offroad Chronicles media.",
    status: "Released game",
    platforms: ["Mobile"],
    roles: ["Studio game"],
    technologies: ["Unity", "Vehicle controls", "Mobile gameplay"],
    heroImage: "/assets/games/pov-car-driving/poster.jpg",
    screenshots: ["/assets/games/pov-car-driving/poster.jpg"],
    trailers: [trailerArchive[1]],
    trailerUrl: trailerArchive[1].url,
    trailerPoster: trailerArchive[1].poster,
    storeUrl: trailerArchive[1].url,
    ctaLabel: "Watch official trailer",
    accent: "#c7483f"
  },
  {
    slug: "offroad-chronicles",
    title: "Offroad Chronicles",
    subtitle: "Off-road driving through mud, snow, steep climbs, and cargo routes.",
    description:
      "Offroad Chronicles is an off-road driving game represented on the Wix page by its official trailer, focused on realistic terrain, first-person driving, winch use, vehicle upgrades, and snow deformation.",
    status: "Released game",
    platforms: ["Android", "Mobile"],
    roles: ["Development work"],
    technologies: ["Unity", "Off-road physics", "Vehicle upgrades", "Terrain systems"],
    heroImage: "/assets/games/offroad-chronicles/poster.jpg",
    screenshots: ["/assets/games/offroad-chronicles/poster.jpg"],
    trailers: [trailerArchive[8]],
    trailerUrl: trailerArchive[8].url,
    trailerPoster: trailerArchive[8].poster,
    storeUrl: trailerArchive[8].url,
    ctaLabel: "Watch official trailer",
    accent: "#7b8f83",
    credits: "Wix gallery note: developed for another publisher by SZ Interactive LTD."
  },
  {
    slug: "gobotix-android",
    title: "GoBotix Android",
    subtitle: "A mobile GoBotix trailer from the official Wix gallery.",
    description:
      "The Wix page includes a GoBotix Android trailer from Ludos Dev, separate from the current Steam listing for Gobotix: Duo.",
    status: "Released game",
    platforms: ["Android", "Mobile"],
    roles: ["Studio game"],
    technologies: ["Unity", "Puzzle gameplay", "Mobile development"],
    heroImage: "/assets/games/gobotix-android/poster.jpg",
    screenshots: ["/assets/games/gobotix-android/poster.jpg"],
    trailers: [trailerArchive[0]],
    trailerUrl: trailerArchive[0].url,
    trailerPoster: trailerArchive[0].poster,
    storeUrl: trailerArchive[0].url,
    ctaLabel: "Watch official trailer",
    accent: "#75a7a2"
  },
  {
    slug: "horror-story-nancy-parker",
    title: "Horror Story: Nancy Parker",
    subtitle: "A horror game trailer from the official Wix gallery.",
    description:
      "Horror Story: Nancy Parker appears in the SZ Interactive Wix gallery through its official reduced-violence trailer.",
    status: "Released game",
    platforms: ["Mobile"],
    roles: ["Studio game"],
    technologies: ["Unity", "Horror atmosphere", "Mobile development"],
    heroImage: "/assets/games/horror-story-nancy-parker/poster.jpg",
    screenshots: ["/assets/games/horror-story-nancy-parker/poster.jpg"],
    trailers: [trailerArchive[3], trailerArchive[4]],
    trailerUrl: trailerArchive[3].url,
    trailerPoster: trailerArchive[3].poster,
    storeUrl: trailerArchive[3].url,
    ctaLabel: "Watch official trailer",
    accent: "#8d3234"
  }
];

export const featuredProjects = projects.slice(0, 2);
export const releasedProjects = projects.slice(2);
export const allTrailers = trailerArchive;
export const findProject = (slug?: string) => projects.find((project) => project.slug === slug);
